import { Component, OnInit,Inject,HostListener } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { HelperService } from '../helper.service';
import { Http, Response,Headers } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { DataTableDirective } from 'angular-datatables';
import {MatDialog} from '@angular/material';
import {MAT_DIALOG_DATA} from '@angular/material';
import { NgForm } from '@angular/forms';
class Data {
  id: number=0;
  name: string='';

}
@Component({
  selector: 'app-student',
  templateUrl: './student.component.html',
  styleUrls: ['./student.component.css'],
  providers: [HelperService] 
})


export class StudentComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
  sygrad=0;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  datas: Data[] = [];
  dtElement: DataTableDirective;
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private activatedRoute: ActivatedRoute,private helper:HelperService,private http:Http, public dialog: MatDialog) { 
  
  }

  ngOnInit() {
  	 this.activatedRoute.params.subscribe((params: Params) => {
        this.sygrad = params['sygrad'];
    
      });

      this.http.get(this.helper.base_url+'http/get/student/'+this.sygrad,{ headers: this.headers })
      .map(this.extractData)
      .subscribe(data => {
      
        this.datas = data;
        
        this.dtTrigger.next();
        
       
      });
  }
  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }
  backbtn(){
    window.history.back();
  }
  openDialog(data) {
   
    const dialogRef = this.dialog.open(StudentDialogBox, {
      height: '350px',
       width: '1000px',
      data: { data: data,sysgrad:this.sygrad },
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log(`Dialog result: ${result}`);
    });
  }
}
@Component({
  selector: 'student-dialog-box',
  templateUrl: "student-dialog-box.html",
})
export class StudentDialogBox {
  users:any=[];
  foods:any=[];
  studentdata:any=[];
  tabledata:any=[];
  sygrad;
  pic:string='';
  no_data=false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,private http:Http) {
    //console.log(data.data.subscription);
    if(data.data.subscription ==0){
      this.no_data=true;
    }
    let image=data.data.pic;

    this.studentdata=data.data;
    //this.pic='http://app.appzoc.com/anns2/backend/storage/app/'+data.data.pic;
   // this.studentdata.pic='http://app.appzoc.com/anns2/backend/storage/app/'+data.data.pic;

    this.sygrad=data.sygrad;


    // this.http.get('http://app.appzoc.com/anns2/backend/http/get/student/'+this.sygrad,)
    // .subscribe(
       
    //     (data) => {
    //              this.users=JSON.parse(data['_body']);
               
    //       // this.refresh();
    //     }, //For Success Response
    //     err => {console.error(err)} //For Error Response
    // );
 
  }
  // user_dialog(userDialog: NgForm){
  
  //   let user=userDialog.value.user;
  //   document.location.href = 'http://192.168.1.20/anns/backend/http/vedio/encrypt/subject/'+this.subid+'/'+this.gradeid+'?user_id='+user;

   

  // }
  ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/student/student.component.ts